import { request } from '@faire/web-api--source';
import { ISearchCatNavBannersRequest } from '@faire/web-api--source/indigofair/data/ISearchCatNavBannersRequest';
import { ISearchCatNavBannersResponse } from '@faire/web-api--source/indigofair/data/ISearchCatNavBannersResponse';
import {
  EndpointOptions,
  PATH,
  RequestOptions,
  SuccessResponse,
} from '@faire/web-api--source/types';

export const path = () => {
  return `/api/v2/products/search/banners`;
};

export const build = (
  data: ISearchCatNavBannersRequest,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  return {
    route,
    url: path(),
    method: 'POST',
    data,
    ...options,
    headers: {
      'content-type': 'application/json',
      ...options?.headers,
    },
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/v2/products/search/banners';

/**
 * Returns data for banners that can be displayed on a search or cat nav results page.
 * Eligibility for each banner is determined independently.
 * Clients may do additional tie-breaking to determine which banners should actually be displayed.
 * Like "banner ads," these "banners" can be displayed almost anywhere on the page,
 * such as replacing a few product tiles inline in search results,
 * interrupting the search results grid with a whole row of content, or appearing below the entire results grid.
 * Each banner proto (e.g. `FreeReturnsBanner`) will contain any additional data needed to render the banner.
 * Some banner protos are empty.
 * If a banner shouldn't be shown for the current page and user, the field will be `null`.
 * Product Area: SEARCH
 */
function execute(
  data: ISearchCatNavBannersRequest
): Promise<ISearchCatNavBannersResponse>;
function execute(
  data: ISearchCatNavBannersRequest,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<ISearchCatNavBannersResponse>>;
function execute(
  data: ISearchCatNavBannersRequest,
  options?: EndpointOptions
): Promise<ISearchCatNavBannersResponse>;
function execute(
  data: ISearchCatNavBannersRequest,
  options?: EndpointOptions
): Promise<
  ISearchCatNavBannersResponse | SuccessResponse<ISearchCatNavBannersResponse>
> {
  const { route, ...requestOptions } = build(data, options);
  return request<ISearchCatNavBannersResponse>(requestOptions);
}
execute[PATH] = 'endpoints/www/api/v2/products/search/banners/post';
export default execute;
